module.exports = __webpack_public_path__ + "img/Rectangle 8.edc0057c.png";